var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 31.998,
    viewBox: "0 0 30 31.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2079",
    x: 2.603,
    y: 3.998,
    width: 26.793,
    height: 28,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#3b4558",
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stop-circle",
    transform: "translate(-1.2 -1.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    d: "M14.2-.8A15,15,0,0,1,24.807,24.807,15,15,0,0,1,3.593,3.593,14.9,14.9,0,0,1,14.2-.8Zm0,27.876A12.876,12.876,0,1,0,1.324,14.2,12.891,12.891,0,0,0,14.2,27.076Z",
    transform: "translate(2 2.064)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "triangle",
    transform: "translate(23.593 10.609) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746",
    transform: "translate(0.653 1.997)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0, -1, 1, 0, -10, 20.4)",
    filter: "url(#Path_2079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2079-2",
    "data-name": "Path 2079",
    d: "M5.653,2a1.353,1.353,0,0,1,1.15.647v0L10.47,8.766l0,.007a1.345,1.345,0,0,1-1.15,2.017H1.983A1.345,1.345,0,0,1,.833,8.772l0-.007L4.5,2.647v0A1.353,1.353,0,0,1,5.653,2Z",
    transform: "translate(22.39 9.34) rotate(90)",
    fill: "#707070"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCircle2);
export default __webpack_public_path__ + "static/media/stop-circle2.2120f1b52fe185538519a9c18bee25cf.svg";
export { ForwardRef as ReactComponent };